__turbopack_context__.v({
  "card": "special-offer-card-module__d_nS0W__card",
  "content": "special-offer-card-module__d_nS0W__content",
  "ctaLink": "special-offer-card-module__d_nS0W__ctaLink",
  "ctaPrimary": "special-offer-card-module__d_nS0W__ctaPrimary",
  "ctaRow": "special-offer-card-module__d_nS0W__ctaRow",
  "dialogCloseBtn": "special-offer-card-module__d_nS0W__dialogCloseBtn",
  "divider": "special-offer-card-module__d_nS0W__divider",
  "eyebrow": "special-offer-card-module__d_nS0W__eyebrow",
  "flyerBar": "special-offer-card-module__d_nS0W__flyerBar",
  "flyerDlIcon": "special-offer-card-module__d_nS0W__flyerDlIcon",
  "flyerPdfIcon": "special-offer-card-module__d_nS0W__flyerPdfIcon",
  "flyerText": "special-offer-card-module__d_nS0W__flyerText",
  "heroImg": "special-offer-card-module__d_nS0W__heroImg",
  "imgWrap": "special-offer-card-module__d_nS0W__imgWrap",
  "offerPanel": "special-offer-card-module__d_nS0W__offerPanel",
  "richHtml": "special-offer-card-module__d_nS0W__richHtml",
  "saveBadge": "special-offer-card-module__d_nS0W__saveBadge",
  "subTitle": "special-offer-card-module__d_nS0W__subTitle",
  "teaser": "special-offer-card-module__d_nS0W__teaser",
  "terms": "special-offer-card-module__d_nS0W__terms",
});
